import React from 'react';
import {ClockIcon, MonitorIcon, RefreshIcon, UserIcon} from '../icons';
import {BrowserMock, PhoneMock} from './AppMockup';
import {CROSS_DEVICE} from './content';

const POINT_ICONS: Record<string, React.FC<{className?: string}>> = {
    fast: ClockIcon,
    sync: RefreshIcon,
    devices: MonitorIcon,
    personal: UserIcon,
};

/**
 * Секция «Как работает»: один гардероб в браузере и в телефоне.
 *
 * Мокапы получают больше половины ширины и выходят за сетку текста — здесь
 * продукт показывает себя сам, а текст его только подписывает. Карточной
 * обёртки нет: она бы уравняла эту секцию с соседями.
 */
const CrossDeviceSection: React.FC = () => (
    <section id="how" className="scroll-mt-20 py-4 sm:py-8" aria-labelledby="landing-how-title">
        <div className="grid lg:grid-cols-[1.25fr_1fr] gap-12 lg:gap-14 items-center">
            <div className="relative min-w-0 order-2 lg:order-1" aria-hidden="true">
                <BrowserMock className="w-full"/>
                <PhoneMock className="hidden sm:block absolute -right-3 md:-right-8 -bottom-8 w-28 md:w-36"/>
            </div>

            <div className="min-w-0 order-1 lg:order-2">
                <h2
                    id="landing-how-title"
                    className="text-3xl sm:text-4xl font-bold leading-[1.06] tracking-[-0.03em] text-ink-900 dark:text-ink-50 text-balance"
                >
                    {CROSS_DEVICE.titleLead}
                    <br/>
                    {CROSS_DEVICE.titleSecond}
                </h2>
                <p className="mt-5 text-base leading-7 text-ink-600 dark:text-ink-300 max-w-[46ch]">
                    {CROSS_DEVICE.text}
                </p>

                <ul className="mt-9 grid grid-cols-2 gap-x-6 gap-y-5">
                    {CROSS_DEVICE.points.map(point => {
                        const Icon = POINT_ICONS[point.id];
                        return (
                            <li key={point.id} className="flex items-center gap-3 min-w-0">
                                <Icon className="w-5 h-5 shrink-0 text-brand-600 dark:text-brand-400"/>
                                <span className="text-sm text-ink-700 dark:text-ink-200 min-w-0">{point.title}</span>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    </section>
);

export default CrossDeviceSection;
